module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/reverb-bucks-payment-card-77fb0cab54a747e403f70c01c6024e2b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/reverb-bucks-payment-card.svg
// module id = e7wu
// module chunks = 24